import './portfolio.css'
import React from 'react'
import Port0 from '../../assets/portfolio0.gif'
import Port1 from '../../assets/portfolio1.png'
import Port2 from '../../assets/portfolio2.png'
import Port3 from '../../assets/portfolio3.png'
import Port4 from '../../assets/portfolio4.png'
import Port5 from '../../assets/portfolio5.png'
import Port6 from '../../assets/portfolio6.png'

const Portfolio = () => {
  const data = [
    {
      id : 0,
      image : Port0,
      title : 'Media House Mern Website',
      github : `https://github.com/Abhishek-Yadav-web/OlivaTrends`,
    },
    {
      id : 1,
      image : Port1,
      title : 'Media House Mern Website',
      github : `https://github.com/Abhishek-Yadav-web/Mern-MediaHouse`,
      demo : `https://mern-mediahouse.netlify.app/`
    },
    {
      id : 2,
      image : Port2,
      title : 'Mi-Clone React Js',
      github : `https://github.com/Abhishek-Yadav-web/mi-clone`,
      demo : `https://miclonestore.netlify.app/`
    },
    {
      id : 3,
      image : Port3,
      title : 'Furniture Website React Js',
      github : `https://github.com/Abhishek-Yadav-web/furniture-website`,
      demo : `https://uidesingfurniture.netlify.app/`
    },
    {
      id : 4,
      image : Port4,
      title : 'Footware Website HTML & CSS',
      github : `https://github.com/WebDevOliva/Footwear.github.io`,
      demo : `https://webdevoliva.github.io/Footwear.github.io/`
    },
    {
      id : 5,
      image : Port5,
      title : 'Spotify-Clone HTML,CSS & JS',
      github : `https://github.com/Abhishek-Yadav-web/myUniverse.github.io`,
      demo : `https://abhishek-yadav-web.github.io/myUniverse.github.io/`
    },
    {
      id : 6,
      image : Port6,
      title : 'Google Keep - clone',
      github : `https://github.com/Abhishek-Yadav-web/Oliva_Notes.github.io`,
      demo : `https://abhishek-yadav-web.github.io/Oliva_Notes.github.io/`
    }
  ]
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>My Portfolio</h2>

      <div className="container portfolio__container">

        {
          data.map((e) => {
            return (
              <>
                {/* ====== PROTFOLIO1 ====== */}
                <article className='portfolio__item'>
                  <div className="portfolio__item-image">
                    <img src={e.image} alt={`portfolio ${e.id}`} />
                  </div>
                  <h3>{e.title}</h3>
                  <div className="portfolio__item-cta">
                    {e.github && <a href={e.github} className='btn' target={'_blank'}>Source Code</a>}
                    {e.demo && <a href={e.demo} className='btn btn-primary' target={'_blank'}>Live Demo</a>}
                  </div>
                </article>
              </>
            )
          })
        }

      </div>
    </section>
  )
}

export default Portfolio